import { Tooltip } from 'react-tooltip' # V5 (Docs: https://react-tooltip.com/docs/v5/options)

export default class Summary extends React.PureComponent
  computeValues: ->
    billableProjects = _.filter(@props.projects, (project) => project.isOwner && !project.openSource)

    activeProjects   = _.filter(billableProjects, (project) => !project.archived)
    archivedProjects = _.filter(billableProjects, (project) => project.archived)

    activeBillableKeysCount   = _.sumBy(activeProjects,   (project) => project.billableKeysCount)
    archivedBillableKeysCount = _.sumBy(archivedProjects, (project) => project.billableKeysCount)

    activePrice   = activeBillableKeysCount   * @props.activeSegmentPrice
    archivedPrice = archivedBillableKeysCount * @props.archivedSegmentPrice
    totalPrice    = activePrice + archivedPrice

    discountsReduction = 0.0

    for line in @props.discounts
      # percentage or flat discount
      if _.includes(line, '%')
        discountLine = totalPrice * parseFloat(line) / 100.0
      else
        discountLine = parseFloat(line)

      discountsReduction += _.round(discountLine, 2)

    return {
      activeBillableKeysCount:   activeBillableKeysCount,
      archivedBillableKeysCount: archivedBillableKeysCount,
      activePrice:               activePrice,
      archivedPrice:             archivedPrice,
      totalPrice:                totalPrice
      discountsReduction:        discountsReduction
      discountedPrice:           _.max([0.0, totalPrice - discountsReduction])
    }

  render: ->
    computedValues  = @computeValues()
    hasBillableKeys = computedValues.activeBillableKeysCount + computedValues.archivedBillableKeysCount > 0

    if !@props.currentUser.free && @props.projects.length > 0 && !@props.hasActiveFilters() && hasBillableKeys
      # Ignore the fact that "frozen keys" exist if nothing frozen
      hasAnyFrozenKeys = computedValues.archivedBillableKeysCount > 0
      activeKeysTitle  = if hasAnyFrozenKeys then 'Active keys:' else "Keys:"

      <div className="summary">
        <table className="summary-popover" data-tooltip-id="summary">
          <tbody>
            <tr>
              <td className="state">{activeKeysTitle}</td>
              <td className="separator"></td>
              <td>
                {computedValues.activeBillableKeysCount}
              </td>
            </tr>

            {
              hasAnyFrozenKeys &&
              <tr>
                <td className="state">Frozen keys:</td>
                <td className="separator"></td>
                <td>
                  {computedValues.archivedBillableKeysCount}
                </td>
              </tr>
            }

            <tr>
              <td className="state">Monthly Price:</td>
              <td className="separator"></td>
              <td>{@props.currencySymbol}{computedValues.totalPrice.toFixed(2)}</td>
            </tr>

            { @renderReduction(computedValues) }
          </tbody>
        </table>
        
        <Tooltip id="summary"
                 variant="light"
                 place="right"
                 offset="12">
          <p className="fw-semi-bold fs-6 pb-2 border-bottom">
            Billable Amount
          </p>
          <p>
            You will be billed monthly, based on
            the number of translated keys in all projects for
            which you are the owner.
          </p>
          <p className="mb-0">
            This amount is a snapshot that can evolve over time.
          </p>
        </Tooltip>
      </div>
    else
      []

  renderReduction: (values) ->
    if values.discountsReduction > 0
      borderTop = { borderTop: '1px solid #cccccc' }

      [
        <tr key="discount" style={{ color: 'green' }}>
          <td className="state">Discount:</td>
          <td className="separator"></td>
          <td>- {@props.currencySymbol}{values.discountsReduction.toFixed(2)}</td>
        </tr>
      ,
        <tr key="discounted-price">
          <td className="state" style={borderTop}></td>
          <td className="separator" style={borderTop}></td>
          <td style={borderTop}><strong>{@props.currencySymbol}{values.discountedPrice.toFixed(2)}</strong></td>
        </tr>
      ]
